module.exports = __webpack_public_path__ + "img/Ivonna-Strehl.ea773c1a.webp";